import axios from "axios";

const getQR = async (siteID, posicionQR) => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    siteID: siteID,
    posicionQR: posicionQR,
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/PointOfSale`, userData, {
    responseType: "blob",
  });
  return response;
};

const qr = { getQR };

export default qr;
